<script lang="ts">
	let { data }: { data: { html: string } } = $props();
</script>

<div class="opisanie">
	<!-- eslint-disable-next-line svelte/no-at-html-tags -->
	{@html data.html ?? 'content'}
</div>
